// extracted by mini-css-extract-plugin
module.exports = {"FiltersPanelSection":"FiltersPanelSection_FiltersPanelSection__1wJ5t","Header":"FiltersPanelSection_Header__lRx8R","Title":"FiltersPanelSection_Title__12OLq"};